import React from "react"
import ReactDOM from "react-dom"
import Carousel from "./carousel-component"

export default class CarouselModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<Carousel {...self.modelJson} />, self.elem)
  }
}
